export default __webpack_public_path__ + "static/media/7.ef78aa2d.jpg";